import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../../graphql.module';
import { GetLegacyMessages } from './queries/GetLegacyMessages.generated';
import { HttpClient } from '@angular/common/http';
import { Uuid } from '../../../../../../graphql';
import { MarkLegacyMessagesAsRead } from './mutations/MarkLegacyMessagesAsRead.generated';
import { DeleteLegacyMessages } from './mutations/DeleteLegacyMessages.generated';

@Injectable({
    providedIn: 'root',
})
export class NotificationApiService {
    #apollo = inject(Apollo);
    #httpClient = inject(HttpClient);

    get #gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    getLegacyMessages() {
        return this.#gql.query({
            query: GetLegacyMessages,
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        });
    }

    getUnreadMessageCount() {
        return this.#httpClient.get<number>(`${window.APP_CONFIG.globalApiEndpoint}notifications/legacymessages/unread/count`);
    }

    markLegacyMessagesAsRead(ids: Uuid[]) {
        return this.#gql.mutate({
            mutation: MarkLegacyMessagesAsRead,
            variables: {
                input: {
                    messageIdList: {
                        ids,
                    },
                },
            },
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        });
    }

    deleteLegacyMessages(ids: Uuid[]) {
        return this.#gql.mutate({
            mutation: DeleteLegacyMessages,
            variables: {
                input: {
                    messageIdList: {
                        ids,
                    },
                },
            },
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        });
    }
}
